

import { Component, Vue, Prop, Watch } from "vue-property-decorator"

// @ts-ignore
import VueDraggableResizable from "vue-draggable-resizable"
// @ts-ignore
import "vue-draggable-resizable/dist/VueDraggableResizable.css"

/**
 * Draggable/resizable overlay panel (drag/resize handled by
 * vue-draggable-resizable). Slots: header, default (body), footer; emits `close`.
 */
@Component({
	components: {
		"vue-draggable-resizable": VueDraggableResizable
	}
})
export default class FloatingPanel extends Vue {
	@Prop({ type: Boolean, default: false }) show!: boolean;
	@Prop({ type: String, default: "" }) title!: string;

	@Prop({ type: Boolean, default: false }) modal!: boolean;

	@Prop({ type: Number, default: 384 }) initialWidth!: number;
	@Prop({ type: Number, default: 480 }) initialHeight!: number;
	@Prop({ type: Number, default: 280 }) minWidth!: number;
	@Prop({ type: Number, default: 220 }) minHeight!: number;

	@Prop({ type: String, default: "" }) panelClass!: string;

	@Prop({ type: Boolean, default: false }) rememberGeometry!: boolean;

	public w: number = this.initialWidth;
	public h: number = this.initialHeight;
	public x: number = 0;
	public y: number = 0;
	private hasSpawned: boolean = false;

	@Watch("show", { immediate: true })
	onShowChanged (val: boolean) {
		if (val) this.$nextTick(() => this.spawn())
	}

	mounted () {
		window.addEventListener("resize", this.spawn)
	}

	beforeDestroy () {
		window.removeEventListener("resize", this.spawn)
	}

	public spawn () {
		if (this.rememberGeometry && this.hasSpawned) return
		this.reset()
		this.hasSpawned = true
	}

	public reset () {
		this.w = this.initialWidth
		this.h = this.initialHeight

		const layer = this.$refs.layer as HTMLElement
		const pw = layer && layer.clientWidth ? layer.clientWidth : window.innerWidth
		const ph = layer && layer.clientHeight ? layer.clientHeight : window.innerHeight

		// Centre horizontally; place vertically at 40% of the spare space (a little above middle).
		this.x = Math.max(0, Math.round((pw - this.w) / 2))
		this.y = Math.max(0, Math.round((ph - this.h) * 0.4))
	}

	public onDrag (x: number, y: number) {
		this.x = x
		this.y = y
	}

	public onResize (x: number, y: number, w: number, h: number) {
		this.x = x
		this.y = y
		this.w = w
		this.h = h
	}

	public close () {
		this.$emit("close")
	}
}

